import { Button, Col, Tooltip } from "antd";
import { damageCaseStatusOptions, IDamageCase, IDamageCaseFetchingInfo, IDamageCaseInitialData, IDamageCaseProps, IDamageCaseStates } from "../../baseInfo/damageCase/interfaces";
import { BaseEntityManager } from "../../components/entityManager";
import { enmControlType, enmPropertyType, IMetadata } from "../../components/entityManager/interfaces";
import { DamageCaseSummary } from "./damageCaseSummary";
import { IssueVoucher } from "./issueVoucher";
import { ICallOptions, enmValidationLevel } from "../../components/infrastructure/models";
import { Core } from "../../components/infrastructure/core";

export class DamageCaseVoucherPaymentDraft extends BaseEntityManager<IDamageCase, IDamageCaseProps, IDamageCaseStates, IDamageCaseFetchingInfo, IDamageCaseInitialData>{
    static initMetadata = (): IMetadata => {
        return {
            title: "پرونده های منتظر پرداخت",
            name: "DamageCaseVoucherPaymentDraft",
            Properties: [
                {
                    title: "شماره پرونده",
                    dataIndex: "Code",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.numberinput,
                    disabled: true,
                    filterable: true,
                    width: 150
                },
                {
                    title: "شماره پیگیری",
                    dataIndex: "TicketNo",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.numberinput,
                    disabled: true,
                    filterable: true,
                    width: 150
                },
                {
                    title: "وضعیت پرونده",
                    dataIndex: "Status",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.combobox,
                    combobox: { options: damageCaseStatusOptions },
                    disabled: true,
                    filterable: true,
                    width: 150
                },
                {
                    title: "سریال بیمه نامه",
                    dataIndex: "PolicyEquipmentModel.Policy.SerialNo",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150
                },
                {
                    title: "کد ملی بیمه گزار/مشتری",
                    dataIndex: "PolicyEquipmentModel.Policy.Policyholder.NationalCode",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150
                },
                {
                    title: "بیمه گزار/مشتری",
                    dataIndex: "PolicyEquipmentModel.Policy.Policyholder.FullName",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: false,
                    sortable: false,
                    width: 200
                },
                {
                    title: "نوع تجهیز",
                    dataIndex: "PolicyEquipmentModel.Equipment.Name",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 120
                },
                {
                    title: "برند",
                    dataIndex: "PolicyEquipmentModel.BrandTitle",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    sortable: true,
                    width: 120
                },
                {
                    title: "مدل",
                    dataIndex: "PolicyEquipmentModel.EquipmentModelTitle",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    sortable: true,
                    width: 120
                },
                {
                    title: "مبلغ قابل پرداخت",
                    dataIndex: "PayableAmount",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.template,
                    filterable: false,
                    sortable: false,
                    width: 180,
                    renderColumn: (_: any, record: IDamageCase) => {
                        let damageCaseEvaluator = record.DamageCaseEvaluators[record.DamageCaseEvaluators.length - 1];
                        let estimation = damageCaseEvaluator ? damageCaseEvaluator.Estimations[damageCaseEvaluator.Estimations.length - 1] : undefined;
                        return (
                            <>
                                {estimation ? `ريال ${estimation.PayableAmount}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : 0}
                            </>
                        );
                    },
                    renderControl: (currentEntity: IDamageCase) => {
                        let damageCaseEvaluator = currentEntity.DamageCaseEvaluators[currentEntity.DamageCaseEvaluators.length - 1];
                        let estimation = damageCaseEvaluator ? damageCaseEvaluator.Estimations[damageCaseEvaluator.Estimations.length - 1] : undefined;
                        return (
                            <b>
                                {estimation ? `ريال ${estimation.PayableAmount}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : 0}
                            </b>
                        );
                    }
                },
                {
                    title: "تاریخ دریافت داغی",
                    dataIndex: "ReceiveDepreciatedDateTime",
                    propertyType: enmPropertyType.date,
                    controlType: enmControlType.date,
                    filterable: true,
                    sortable: true,
                    width: 120
                }

            ]
        };
    }
    onInitializing() {
        this.searchable = true;
        this.searchArea = {
            columnsPerRow: 2
        };

        this.extraHeaderButtons = () => {
            let buttons: React.ReactNode[] = [];
            let issueVoucherAccess = this.initialData?.AccessList["IssueVoucher"];
            if (issueVoucherAccess)
                buttons.push(<Button key="IssueVoucher" style={{ lineHeight: '0.5em', verticalAlign: 'middle', width: '100px' }} type="primary" onClick={this.issueVoucher}>صدور حواله</Button>);

            return buttons;
        };

        this.renderingToolbar = () => {
            if (!this.selectedEntity)
                return <></>;

            let commands: React.ReactNode[] = [];
            if (!this.selectedEntity?.SentToBranch && this.initialData?.AccessList["SendDamageCaseToBranch"])
                commands.push(
                    <Col key="sendDamageCaseToBranch" style={{ marginLeft: 10 }}>
                        <Tooltip key="sendDamageCaseToBranch" title="ارسال پرونده خسارت به شعبه مربوطه از طریق اتوماسیون اداری سامان">
                            <Button key="sendDamageCaseToBranch"
                                style={{ lineHeight: '0.5em', verticalAlign: 'middle', width: '140px' }}
                                type="primary"
                                onClick={this.sendDamageCaseToBranch}
                            >
                                ارسال به شعبه
                            </Button>
                        </Tooltip >
                    </Col>
                );

            if (this.initialData?.AccessList["PrintDamageCaseSummary"])
                commands.push(
                    <Col key="SendToEvaluation" style={{ marginLeft: 10 }}>
                        <Button key="printDamageCaseSummary" style={{ lineHeight: '0.5em', verticalAlign: 'middle', width: '140px' }} type="primary" onClick={this.showDamageCaseSummary} loading={this.state.loading}>چاپ خلاصه پرونده</Button>
                    </Col>
                );

            return commands.length ? (<> {commands} </>) : (<></>);
        };
    }
    sendDamageCaseToBranch = async () => {
        let damageCase = this.selectedEntity;
        if (!damageCase || !!damageCase.SentToBranch) return;
        let fetchOpt: ICallOptions = {
            url: "damagecaseevaluator/senddamagecasetobranch",
            data: { damageCaseId: damageCase.Id, rowVrsn: damageCase.RowVrsn },
            onSuccess: res => {
                if (res.ValidationState.Successful && !res.ValidationState.ValidationResults.filter(v => v.Level === enmValidationLevel.Warning).length) {
                    Core.successNotification("پرونده خسارت با موفقیت از طریق اتوماسیون اداری برای شعبه ارسال شد.");
                    this.fetchData();
                }
            }
        };
        await this.callApi(fetchOpt);
    }
    issueVoucher = () => {
        this.addLookupForm("IssueVoucher",
            <IssueVoucher
                key="IssueVoucher"
                params={() => {
                    return { filter: this.filter ?? this.headerFilter };
                }}
                onClose={this.onLookupClosed}
                invokePath={this.metadata.title}
            />
        );
    }
    showDamageCaseSummary = () => {
        this.addLookupForm('DamageCaseSummary',
            <DamageCaseSummary
                damageCaseId={this.selectedEntity!.Id}
                onClose={() => this.closeLookupForm()}
                invokePath={this.metadata.title}
                invoker={'damagecasevoucherpaymentdraft'}
            />
        );
    }
}